import { formatISO } from 'date-fns';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { ReactElement } from 'react';

import Header from '@/modules/workingDay/components/Main/Header';
import JobInstances from '@/modules/workingDay/components/Main/JobInstances';
import { Typography } from '@/shared/components/atoms';

export default function WorkingDay(): ReactElement {
  const { query, replace } = useRouter();
  const { t } = useTranslation();
  const [filter, setFilter] = React.useState({
    search: '',
    date: query?.date
      ? String(query.date)
      : formatISO(new Date(), { representation: 'date' }),
  });

  // set tab default value
  React.useEffect(() => {
    if (filter.date) {
      replace({
        query: {
          ...query,
          date: filter.date,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.date]);

  return (
    <section>
      <Header date={filter.date} setFilter={setFilter} />
      {query?.jobInstancesCount && (
        <Typography variant='h3' weight='bold' className='mt-8 text-black'>
          {query?.jobInstancesCount} {t('job-order')}
        </Typography>
      )}

      {query?.number && (
        <Typography
          variant='subtitle1'
          weight='bold'
          className='mt-8 text-text-600'
        >
          {t('plot')} {query?.number}
        </Typography>
      )}
      <JobInstances filter={filter} />
    </section>
  );
}
